import { apiFetch } from '../../lib/api';

export interface ElternEintrag {
  id: number;
  name: string | null;
  email: string | null;
  telefon: string | null;
  notiz: string | null;
  rolle: 'mutter' | 'vater' | 'grosseltern' | 'betreuer' | 'unbekannt';
  ist_hauptkontakt: 0 | 1;
  eltern_schueler_id: number;
}

export type Rolle = ElternEintrag['rolle'];
export const ROLLEN: { value: Rolle; label: string }[] = [
  { value: 'mutter',      label: 'Mutter' },
  { value: 'vater',       label: 'Vater' },
  { value: 'grosseltern', label: 'Großeltern' },
  { value: 'betreuer',    label: 'Betreuer/in' },
  { value: 'unbekannt',   label: 'Unbekannt' },
];

// Welle S4b: lokaler Fetch-Klon entfernt — zentraler apiFetch aus lib/api
export const elternApi = {
  laden: (schuelerId: number) =>
    apiFetch<{ eltern: ElternEintrag[] }>(`/api/schueler/${schuelerId}/eltern`),

  hinzufuegen: (schuelerId: number, payload: {
    name?: string; email: string; telefon?: string; notiz?: string;
    rolle: Rolle; ist_hauptkontakt: boolean;
  }) =>
    apiFetch<{ eltern_id: number; eltern_schueler_id: number }>(
      `/api/schueler/${schuelerId}/eltern`,
      { method: 'POST', body: JSON.stringify(payload) }
    ),

  aktualisierenEltern: (id: number, patch: { name?: string; email?: string; telefon?: string; notiz?: string }) =>
    apiFetch<{ eltern: any }>(`/api/eltern/${id}`, {
      method: 'PATCH', body: JSON.stringify(patch),
    }),

  aktualisierenLink: (id: number, patch: { rolle?: Rolle; ist_hauptkontakt?: boolean }) =>
    apiFetch<{ verknuepfung: any }>(`/api/eltern-schueler/${id}`, {
      method: 'PATCH', body: JSON.stringify(patch),
    }),

  // Welle U7: ganzen Elterndatensatz löschen (alle Kind-Verknüpfungen)
  loeschenEltern: (elternId: number) =>
    apiFetch<{ ok: boolean; verknuepfungen_entfernt: number }>(`/api/eltern/${elternId}`, { method: 'DELETE' }),

  loeschen: (elternSchuelerId: number) =>
    apiFetch<{ ok: boolean }>(`/api/eltern-schueler/${elternSchuelerId}`, { method: 'DELETE' }),

  unvollstaendig: () =>
    apiFetch<{ count: number; beispiele: { schueler_id: number; schueler_name: string; klasse_name: string }[] }>(
      '/api/eltern/unvollstaendig'
    ),
};
